<template>
  <hide-at :breakpoints="{ small: 769 }" breakpoint="small">
    <footer>
      <ul>
        <li><a href="/terms">{{ $t("terms") }}</a></li>
        <li><a href="/privacy">{{ $t("privacy") }}</a></li>
        <li v-if="lang == 'en'"><a href="/hrp">Human Right Policy</a></li>
        <li><a href="/doc/notice_at_collection.pdf" target="_blank">Notice at
            Collection</a></li>
      </ul>
    </footer>
  </hide-at>
</template>


<script>
import { hideAt } from 'vue-breakpoints';
export default {
  name: 'appfooter',
  components: {
    hideAt
  },
  computed: {
    lang() {
      return this.$store.state.locales.locale
    }
  }
}
</script>